import React, { useEffect, useState } from 'react';
import AssessmentIcon from '../../common/AssessmentIcon';
import { pick } from './configs/common';
import dass42 from './configs/dass42';
import sdq from './configs/sdq';
import ryff from './configs/ryff';
import riasec from './configs/riasec';
import './testShell.css';

const CONFIGS = { dass42, sdq, ryff, riasec };
const reducedMotion = () => typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * The moment between picking a test and its first message: the test's icon, name and a thin
 * progress line over the chat while the session starts, then a soft fade into the greeting.
 * Chatbot.js shows it from the tap on Start until the test reports it's ready (onReady).
 */
const TestLaunch = ({ show, testKey, language = 'en' }) => {
  const lang = language === 'fil' ? 'fil' : 'en';
  const [shownKey, setShownKey] = useState(show ? testKey : null);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (show && testKey) {
      setShownKey(testKey);
      setLeaving(false);
      return undefined;
    }
    if (!shownKey) return undefined;
    setLeaving(true);
    const id = window.setTimeout(() => {
      setShownKey(null);
      setLeaving(false);
    }, reducedMotion() ? 0 : 360);
    return () => window.clearTimeout(id);
  }, [show, testKey]);

  const config = CONFIGS[shownKey];
  if (!config) return null;
  return (
    <div className={`ts-launch${leaving ? ' is-out' : ''}`} role="status" aria-live="polite">
      <div className="ts-launch-inner">
        <span className="ts-launch-tile">
          <AssessmentIcon type={shownKey} size={38} />
        </span>
        <strong className="ts-launch-title">{pick(config.names.title, lang)}</strong>
        <span className="ts-launch-code">{config.names.code}</span>
        <span className="ts-launch-bar" aria-hidden="true">
          <i />
        </span>
        <span className="ts-launch-note">
          {lang === 'fil' ? 'Inihahanda ang mga tanong…' : 'Getting your questions ready…'}
        </span>
      </div>
    </div>
  );
};

export default TestLaunch;
